import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-link-address-change',
  templateUrl: './link-address-change.component.html',
  styleUrls: ['./link-address-change.component.scss']
})
export class LinkAddressChangeComponent implements OnInit {
form:FormGroup
  constructor(
    private formBuilder:FormBuilder,
    private applicationDataService:ApplicationDataService,
    private toastr: NotificationService
  ) { }

  ngOnInit(): void {
    this.form=this.formBuilder.group({
      existingApplicationNo:[null,Validators.required],
      newApplicationNo:[null,Validators.required],
    })
  }
  clearFilter(){
    this.form.reset();
  }
  Submit(){
    if(this.form.valid){
    let value=this.form.value;
    console.log(value);
    this.applicationDataService.saveLinkAddressChange(value).subscribe((result)=>{
      if(result){
      this.toastr.showSuccess("Application Linked Successfully!")
        this.form.reset()
    }
    else
    this.toastr.showError("Application Link Failed!")
    })
    }
  }
}
